import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import VersionRemarksModalSF from '../../../components/superUser/settings/VersionRemarksModalSF.js'

const DocTemplatePageUI = ({ context, objectList, errorList, onGetVersion, onRefreshClick, onDownloadClick,
  addRemarksMode, onAddRemarksCancel, onAddRemarksClick, selectedFileName, selectedVersion,
}) =>
  <SuperUserSettingsPageUI context={context} className='pg_su_props' topnav='settings' backLink='/su/docTemplates'
    headerText='Document Template' centered={!objectList && !errorList} page='docTemplates'
  >
    {
      !objectList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      objectList &&

      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Loan Document Templates</b></span>
          </span>
        }
        right={
          <span />
        }
      />
    }
    {
      objectList && objectList.length !== 0 &&
      <DocTemplateUI objectList={objectList} onGetVersion={onGetVersion} onDownloadClick={onDownloadClick} onAddRemarksClick={onAddRemarksClick} />
    }
    <VersionRemarksModalSF context={context} addRemarksMode={addRemarksMode} onAddRemarksCancel={onAddRemarksCancel}
      onRefreshClick={onRefreshClick} selectedFileName={selectedFileName} selectedVersion={selectedVersion} />
  </SuperUserSettingsPageUI>

const DocTemplateUI = ({ objectList, onGetVersion, onDownloadClick, onAddRemarksClick }) =>
  <CardUI className='g_m_bottom_100'>
    <table>
      <tbody>
        {
          objectList.map((object, i) =>
            <React.Fragment key={i}>
              <tr>
                <td>
                  {
                    object.versionList ?
                      <span className='icon icon-angle-down g_m_right_50 g_cursor_pointer' onClick={onGetVersion} data-object-id={object.fileName} data-version={object.version} /> :
                      <span className='icon icon-angle-right g_m_right_50 g_cursor_pointer' onClick={onGetVersion} data-object-id={object.fileName} data-version={object.version} />
                  }
                </td>
                <td>
                  {object.fileName}
                </td>
              </tr>
              {
                object.versionList && object.versionList.map((objVer, j) =>
                  <React.Fragment key={j}>
                    <tr>
                      <td />
                      <td>{objVer.version}</td>
                      <td className='g_p_left_100'>{objVer.size} bytes</td>
                      <td className='g_p_left_100'>{objVer.lastModifiedF}</td>
                      <td className='g_p_left_100'>
                        <span className="icon icon-download g_muted g_m_right_50 g_cursor_pointer" onClick={onDownloadClick} data-object-id={object.fileName} data-version={objVer.version} />
                        <span className='icon icon-pencil g_link_2' onClick={onAddRemarksClick} data-object-id={object.fileName} data-version={objVer.version} />
                      </td>
                    </tr>
                    {
                      (objVer.tag || objVer.remarks) &&
                      <tr>
                        <td />
                        <td colSpan={4}>
                          <BadgeUI label={objVer.tag} className='g_m_right_50' />
                          {objVer.remarks}
                        </td>
                      </tr>
                    }
                  </React.Fragment>
                )
              }
            </React.Fragment>
          )
        }
      </tbody>
    </table>
  </CardUI>



export default DocTemplatePageUI

